import { combineReducers } from "redux";
import companies from "./companies";
import customers from "./customers";
export default combineReducers({
    companies,
    customers,
});
